<div class="event-page">
  <div class="page-header">
    <app-back-button
      parentRoute="/admin/process-management/processes"
      [title]="pageHeading().title"
      [subtitle]="pageHeading().subtitle"
    ></app-back-button>
    <div class="header-actions">
      <app-secondary-button
        title="Refresh data"
        icon="refresh"
        size="small"
        [disable]="loading()"
        [loading]="loading()"
        (action)="reload()"
      ></app-secondary-button>
      <app-secondary-button
        title="Notify people"
        icon="pi pi-bell"
        size="small"
        [disable]="!event()"
        (action)="notifyPeople()"
      ></app-secondary-button>
    </div>
  </div>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  }

  @if (event(); as selectedEvent) {
    <header class="event-heading">
      <div>
        <h2>{{ selectedEvent.displayName | translate }}</h2>
        @if (selectedEvent.description) {
          <p class="event-description">{{ selectedEvent.description | translate }}</p>
        }
        <app-copyable-identifier [value]="selectedEvent.key"></app-copyable-identifier>
      </div>
    </header>

    @if (selectedEvent.samplePayloadJson) {
      <section class="event-section">
        <h3>{{ 'Sample payload' | translate }}</h3>
        <pre><code>{{ selectedEvent.samplePayloadJson | prettyJson }}</code></pre>
      </section>
    }

    <section class="event-section orch-table-panel">
      <app-orchestration-table-heading heading="Event triggers" [(query)]="triggerSearch">
        <p class="section-hint">{{ 'Which rule reacted and which process started' | translate }}</p>
        <div tableActions class="table-actions">
          <app-secondary-button
            title="Create event trigger"
            icon="pi pi-plus"
            size="small"
            [disable]="!event()"
            (action)="createTrigger()"
          ></app-secondary-button>
        </div>
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="triggerColumns()"
        [data]="visibleTriggers()"
        [config]="triggerTableConfig"
        [loading]="loading()"
      ></app-data-table>
    </section>

    <section class="event-section orch-table-panel">
      <app-orchestration-table-heading heading="Recent executions" [(query)]="executionSearch">
        <p class="section-hint">{{ 'Who published the event and which assignment started' | translate }}</p>
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="executionColumns()"
        [data]="visibleExecutions()"
        [config]="executionTableConfig"
        [loading]="loading()"
      ></app-data-table>
    </section>
  } @else if (loading()) {
    <app-loading [loading]="true"></app-loading>
  } @else {
    <div class="empty-state">{{ 'No events found' | translate }}</div>
  }
</div>

<ng-template #triggerNameTemplate let-row>
  <app-orchestration-identity-cell [name]="row.name" [lines]="row.identityLines"></app-orchestration-identity-cell>
</ng-template>

<ng-template #triggerStatusTemplate let-row>
  <p-tag [value]="row.statusLabel | translate" [severity]="row.statusSeverity"></p-tag>
</ng-template>

<ng-template #triggerExecutionsTemplate let-row>
  <div class="executions-cell">
    <strong>{{ row.executionCount }}</strong>
    <small>
      {{ 'Succeeded' | translate }}: {{ row.successfulExecutionCount }},
      {{ 'Failed' | translate }}: {{ row.failedExecutionCount }}
    </small>
  </div>
</ng-template>

<ng-template #lastPublisherTemplate let-row>
  <app-copyable-identifier [value]="row.lastSourceAssignmentId || ''" [link]="row.lastSourceAssignmentUrl"></app-copyable-identifier>
</ng-template>

<ng-template #lastStartedTemplate let-row>
  <app-copyable-identifier [value]="row.lastTargetAssignmentId || ''" [link]="row.lastTargetAssignmentUrl"></app-copyable-identifier>
</ng-template>

<ng-template #executionStateTemplate let-row>
  <p-tag [value]="row.state | translate" [severity]="row.stateSeverity"></p-tag>
</ng-template>

<ng-template #executionEventIdTemplate let-row>
  @if (row.eventId) {
    <span class="muted">{{ row.identifierLabel | translate }}</span>
    <app-copyable-identifier [value]="row.eventId" [link]="row.eventIdUrl"></app-copyable-identifier>
  } @else {
    <span>—</span>
  }
</ng-template>

<ng-template #executionPublisherTemplate let-row>
  <app-copyable-identifier [value]="row.sourceAssignmentId || ''" [link]="row.sourceAssignmentUrl"></app-copyable-identifier>
</ng-template>

<ng-template #executionStartedTemplate let-row>
  <app-copyable-identifier [value]="row.targetAssignmentId || ''" [link]="row.targetAssignmentUrl"></app-copyable-identifier>
</ng-template>
